import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { EntradaDiente } from "app/models/odontograma.interface";
import {
  POR_DIENTE_QUE_LIMPIAN_CARAS,
  CARAS,
  NOMBRES_FDI,
  CondicionConfig,
} from "../catalogo-condiciones";
import { OdontogramaConfigService } from "app/services/odontograma-config.service";

export interface CaraPopoverData {
  fdi: string;
  entry: EntradaDiente;
}

@Component({
  selector: "app-cara-popover",
  templateUrl: "./cara-popover.component.html",
  styleUrls: ["./cara-popover.component.scss"],
})
export class CaraPopoverComponent {
  form: FormGroup;
  fdi: string;
  nombreFdi: string;
  caras = CARAS;
  condicionesCara: CondicionConfig[];
  condicionesDiente: CondicionConfig[];

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<CaraPopoverComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CaraPopoverData,
    private configService: OdontogramaConfigService,
  ) {
    this.fdi = data.fdi;
    this.nombreFdi = NOMBRES_FDI[data.fdi] ?? data.fdi;
    this.condicionesCara = this.configService.cara.filter((c) => !c.oculto);
    this.condicionesDiente = this.configService.diente.filter((c) => !c.oculto);

    this.form = this.fb.group({
      tooth: [data.entry?.tooth ?? null],
      surfaces: this.fb.control(data.entry?.surfaces ?? {}),
      notas: [data.entry?.notas ?? null],
    });
  }

  onToothChange(value: string | null): void {
    if (value && POR_DIENTE_QUE_LIMPIAN_CARAS.includes(value)) {
      this.form.get("surfaces")?.setValue({});
    }
  }

  setCara(cara: string, condicion: string | null): void {
    const surfaces = { ...(this.form.get("surfaces")?.value || {}) };
    if (condicion) {
      surfaces[cara] = condicion;
    } else {
      delete surfaces[cara];
    }
    this.form.get("surfaces")?.setValue(surfaces);
  }

  guardar(): void {
    const v = this.form.value;
    const entry: EntradaDiente = {
      tooth: v.tooth || null,
      surfaces: v.surfaces || {},
      notas: v.notas || null,
    };
    this.dialogRef.close(entry);
  }

  limpiarDiente(): void {
    this.dialogRef.close({ tooth: null, surfaces: {}, notas: null });
  }

  cancelar(): void {
    this.dialogRef.close();
  }
}
